import { useEffect, useState } from 'react'

import { ReceptionCallHistory, getRedial } from '@reception-web/common/api/www'
import { REDIAL_EXPIRED_TIME } from '@reception-web/common/consts'
import useSWR from 'swr'

const INTERVAL_TIME = 1000 * 5

export const useRedialApi = (deviceId?: string) => {
  const [timerExpired, setTimerExpired] = useState(false)
  const { data, error } = useSWR<ReceptionCallHistory | undefined>(
    deviceId && `/aos/redial/${deviceId}`,
    async () => {
      if (!deviceId) {
        return undefined
      }

      const dateAfter = new Date(
        new Date().getTime() - REDIAL_EXPIRED_TIME
      ).toISOString()

      const res = await getRedial(deviceId, {
        date_after: dateAfter,
      })
      return res.data
    },
    {
      refreshInterval: timerExpired ? 0 : INTERVAL_TIME,
      // Disable cache
      dedupingInterval: 0,
      revalidateOnMount: true,
      revalidateIfStale: true,
      fallbackData: undefined,
    }
  )

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimerExpired(true)
    }, REDIAL_EXPIRED_TIME)
    return () => clearTimeout(timer)
  }, [])

  return {
    data,
    error,
  }
}
